import { render, staticRenderFns } from "./Seasonalities.vue?vue&type=template&id=34958222"
import script from "./Seasonalities.vue?vue&type=script&lang=js"
export * from "./Seasonalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports